<template>
  <CBox display="flex" flexDirection="column">
    <CFlex mb="24px">
      <OmtTypography as="h1-bold" color="var(--colors-light-primary-navy-blue)">
        O que deseja encontrar?
      </OmtTypography>
    </CFlex>
    <OmtRow mb="24px">
      <OmtInput
        v-model="inputText"
        variant="filled"
        placeholder="Busque pelo nome do profissional ou clínica"
        icon-right="search"
        :iconRightClick="onSearch"
        @keydown.enter.prevent="onSearch"
      />
    </OmtRow>
    <OmtRow>
      <CBox>
        <OmtTile
          v-for="(type, index) in filteredEstablishments"
          :key="index"
          cursor="pointer"
          :icon="type.icon"
          :divider="index < filteredEstablishments.length - 1"
          @click="onTypeClick(type)"
        >
          <OmtTypography as="h2-semi-bold" color="#4A5E77">
            {{ type.title }}
          </OmtTypography>
        </OmtTile>
      </CBox>
    </OmtRow>
    <CBox d="flex" justifyContent="center" mt="24px" cursor="pointer"
@click="onShowInactiveClick">
      <OmtTypography as="p2" color="#4A5E77" mt="24px" text-decoration="underline">
        Consultar credenciados {{ inativos ? "ativos" : "inativos" }}
      </OmtTypography>
    </CBox>
  </CBox>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from "vuex";
import { capitalizeWords } from "@/utils/utils";

export default {
  name: "TypeStablishment",
  data() {
    return {
      inputText: "",
      establishments: []
    };
  },
  computed: {
    ...mapGetters("openNetworkSearch", ["getSelectedEstablishmentType", "getTipoAtendimentoAnonimo"]),
    ...mapState("openNetworkSearch", ["selectedEstablishmentType", "inativos"]),
    filteredEstablishments() {
      if (!this.inputText) return this.establishments;
      const search = this.inputText.toLowerCase();
      return this.establishments.filter(e => e.title.toLowerCase().includes(search));
    }
  },
  methods: {
    ...mapActions("openNetworkSearch", ["setEstablishmentType", "fetchTipoAtendimentoAnonimo"]),
    ...mapMutations("openNetworkSearch", ["SET_REDE", "SET_ESPECIALIDADES_ANONIMO", "SET_INATIVOS"]),
    onSearch() {
      return;
    },
    onTypeClick(type) {
      this.setEstablishmentType(type);
      this.SET_REDE(type?.CodigoRede);
      this.SET_ESPECIALIDADES_ANONIMO(null);
      this.$router.push({ name: "network.specialities" });
    },
    getIconName(TipoView) {
      switch (TipoView) {
        case "vacinas":
          return "syringe";
        case "covid":
          return "virus";
        case "prontsoc":
          return "truck-medical";
        case "mediclin":
          return "user-doctor";
        case "laborato":
          return "flask";
        case "pshospital":
          return "baby-carriage";
        case "hospital":
          return "hospital";
        case "dentclin":
          return "tooth";
        case "terapia":
          return "clipboard-list-check";
        default:
          return "hospital";
      }
    },
    async onShowInactiveClick() {
      await this.SET_INATIVOS(!this.inativos);
    }
  },
  async mounted() {
    this.$root.$emit("show-loading");
    await this.fetchTipoAtendimentoAnonimo();

    this.$root.$emit("hide-loading");

    const tipoList = this.getTipoAtendimentoAnonimo || [];

    this.establishments = tipoList.map(g => ({
      title: capitalizeWords(g.DescricaoTipoAtendimento),
      icon: this.getIconName(g.TipoView),
      ...g
    }));
  }
};
</script>
